import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

import { useGlobalCopyStore } from '../../../common'

interface OnboardingCreditScoreProps {
  creditScore: number
  setCreditScore: (value: number) => void
}

const OnboardingCreditScore = ({ creditScore, setCreditScore }: OnboardingCreditScoreProps) => {
  const { finstrong: copy } = useGlobalCopyStore()

  const isValid = !isNaN(creditScore)

  return (
    <Box sx={{ p: 24 }}>
      <TextField
        error={!isValid}
        fullWidth={true}
        inputMode="numeric"
        label={copy.credit_score}
        onChange={(e) => setCreditScore(Number(e.target.value))}
        slotProps={{
          htmlInput: {
            noValidate: true,
            pattern: '[0-9]*',
          },
        }}
        value={isValid ? creditScore : ''}
      />
    </Box>
  )
}

export default observer(OnboardingCreditScore)
